import api from "../utils/interceptor";
const API_URL = process.env.REACT_APP_API_URL;

export const PUBLIC_ASSETS_BASE_URL = (API_URL || "").replace(/\/api\/?$/, "/public/");

export const getTransactionHistoryService = async (
  mobileNo,
  { page = 1, perPage = 5 } = {}
) => {
  try {
    const response = await api.get(API_URL + "transaction-index", {
      params: { mobile_no: mobileNo, page, per_page: perPage },
      headers: { "Content-Type": "application/json" },
    });
    return response;
  } catch (error) {
    console.error("Error fetching transaction history:", error);
    throw error;
  }
};

export const getRpaTransactionHistoryService = async (
  mobileNo,
  { page = 1, perPage = 5 } = {}
) => {
  try {
    const response = await api.get(API_URL + "rpa.transaction-index", {
      params: { mobile_no: mobileNo, page, per_page: perPage, is_rpa: 1 },
      headers: { "Content-Type": "application/json" },
    });
    return response;
  } catch (error) {
    console.error("Error fetching RPA transaction history:", error);
    throw error;
  }
};

export const buildAttachmentUrl = (path) => {
  if (!path || !path.trim()) return null;
  const p = path.trim();
  if (/^https?:\/\//i.test(p)) return p;
  const rel = p.startsWith("/") ? p.substring(1) : p;
  return PUBLIC_ASSETS_BASE_URL + rel;
};
